import React from "react";
import { cva } from "class-variance-authority";
import { cn } from "../../lib/utils";

// Geometry follows the design system's .badge family: rounded-md, not a pill.
const badgeVariants = cva(
  "inline-flex items-center rounded-md px-2 py-0.5 text-xs",
  {
    variants: {
      variant: {
        // .badge-solid — emphasis; use sparingly, one per group.
        default: "bg-primary-900 font-medium text-on-primary",
        accent: "bg-danger-900 font-medium text-on-primary",
        // .badge — the neutral default for plain tags.
        outline: "border border-gray-200 bg-white text-gray-700",
        // .badge-tint — sky-tinted chip for entities/people.
        tint: "border border-info-300 bg-info-50 text-primary-900",
        error: "border border-danger-300 bg-danger-50 text-danger-900",
        // Success has no counterpart in the palette (primary/danger/info +
        // gray only), so it borrows green — the one deliberate exception.
        success: "border border-green-200 bg-green-50 text-green-800",
        secondary: "bg-gray-100 text-gray-700",
      },
    },
    defaultVariants: {
      variant: "default",
    },
  }
);

function Badge({ className, variant, ref, ...props }) {
  return (
    <span
      ref={ref}
      className={cn(badgeVariants({ variant }), className)}
      {...props}
    />
  );
}

export { Badge, badgeVariants };
